
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings/[id]/[name]",
      function () {
        return require("private-next-pages/listings/[id]/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listings/[id]/[name]"])
      });
    }
  